<template>
  <div class="container_self">
    <el-row class="table_parent">
      <h3>分类列表</h3>
      <el-button type="success" @click="addCategory" icon="el-icon-plus" size="mini"
        >添加分类</el-button
      >
      <el-table :data="categoryList" style="margin-top: 15px" v-loading="loading">
        <el-table-column label="分类名称" prop="name" align="center"></el-table-column>
        <el-table-column
          label="parentId"
          prop="parentId"
          align="center"
        ></el-table-column>
        <el-table-column label="排序" prop="sorted" align="center"></el-table-column>

        <el-table-column label="操作" align="center">
          <template slot-scope="scope">
            <el-button size="mini" type="primary" @click="updateCategory(scope.row)"
              >更新</el-button
            >
            <el-button size="mini" type="danger" @click="deleteCategory(scope.row.id)"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </el-row>

    <el-dialog :title="string + '分类'" :visible.sync="dialogFormVisible">
      <el-form
        :model="addCategoryForm"
        :rules="rules"
        size="mini"
        inline
        ref="addCategoryForm"
        label-width="100px"
      >
        <el-form-item label="分类名称" prop="name">
          <el-input v-model="addCategoryForm.name"></el-input>
        </el-form-item>
        <el-form-item label="父分类" prop="parentId">
          <el-input v-model="addCategoryForm.parentId"></el-input>
        </el-form-item>
        <el-form-item label="排序" prop="sorted">
          <el-input v-model="addCategoryForm.sorted"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitCategoryForm('addCategoryForm')">
          保 存
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { axiosGet, axiosPost } from "@/assets/ajaxFn";
export default {
  data() {
    return {
      loading: false,
      categoryList: [],
      string: "新增",
      dialogFormVisible: false,
      addCategoryForm: {
        name: "",
        parentId: 0,
        sorted: "",
      },
      rules: {
        name: [{ required: true, message: "请输入分类名称", trigger: "blur" }],
        parentId: [{ required: true, message: "请选择父分类", trigger: "change" }],
        sorted: [{ required: true, message: "请输入排序", trigger: "blur" }],
      },
    };
  },
  methods: {
    async getCategoryList() {
      this.loading = true;
      await axiosGet("/api/video/classify/list").then((res) => {
        if (res.code == 0) {
          this.categoryList = res.data;
        }
      });
      this.loading = false;
    },
    deleteCategory(id) {
      this.$confirm("此操作将永久删除该分类, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        axiosPost("/api/video/classify/delete", { id: id }, "JSON").then((res) => {
          if (res.code == 0) {
            this.$message({ message: "删除成功", type: "success" });
            this.getCategoryList();
          }
        });
      });
    },
    async addCategory() {
      this.string = "新增";
      this.dialogFormVisible = true;
      this.addCategoryForm = {
        name: "",
        parentId: "",
        sorted: 0,
      };
      this.$refs.addCategoryForm.resetFields();
    },
    updateCategory(row) {
      this.string = "更新";
      this.dialogFormVisible = true;
      this.addCategoryForm = {
        name: row.name,
        parentId: row.parentId,
        sorted: row.sorted,
        id: row.id,
      };
    },
    async submitCategoryForm(formName) {
      const valid = await new Promise((resolve) => {
        this.$refs[formName].validate((valid) => {
          resolve(valid);
        });
      });
      if (valid) {
        let url =
          this.string == "新增"
            ? "/api/video/classify/add"
            : "/api/video/classify/update";
        await axiosPost(url, this.addCategoryForm, "JSON").then((res) => {
          if (res.code == 0) {
            this.$message({ message: "分类" + this.stiing + "成功", type: "success" });
            this.$refs.addCategoryForm.resetFields();
            this.dialogFormVisible = false;
            this.getCategoryList();
          }
        });
      }
    },
  },
  created() {
    this.getCategoryList();
  },
};
</script>



// WEBPACK FOOTER //
// src/components/view/TvVideoManager/videoCategory.vue